import React from "react";
import { Navigate } from "react-router-dom";

function Settings() {
  return <Navigate to="/settings/sqlbase" replace />;
}

export default Settings;
